// CSS
import "./BigPrimaryButton.css"

/** 
 * This component renders a submit button with the available styles:
 * - default
 * - secondary
 * 
 * @param   {string} children The text displayed in the button.
 * @param   {string} buttonStyle The style to render the button in.
 * @returns {ReactElement} A React element that renders a submit button. 
 */
export default function SubmitButton({children, buttonStyle}) {
    return (
        <input className={`primary-button ${buttonStyle}`} type="submit" value={children}></input>
    )
}